module.exports = "<rect x=\"4\" y=\"10\" width=\"14\" height=\"2\"/>\n<rect x=\"10\" y=\"4\" width=\"2\" height=\"14\"/>\n"